import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MenuCollapse = function MenuCollapse(props) {
  return /*#__PURE__*/ _jsxs(
    "svg",
    _extends(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
      },
      props,
      {
        children: [
          /*#__PURE__*/ _jsx("path", {
            fill: "transparent",
            fillOpacity: 0.01,
            d: "M8.32999 3V22M20.98 18.5C20.95 19.3 20.87 19.83 20.65 20.27C20.35 20.87 19.86 21.35 19.27 21.65C18.59 22 17.71 22 15.93 22H7.05999C5.28999 22 4.39999 22 3.71999 21.65C3.11999 21.35 2.63999 20.86 2.33999 20.27C1.98999 19.59 1.98999 18.71 1.98999 16.93V8.07C1.98999 6.3 1.98999 5.41 2.33999 4.73C2.63999 4.13 3.12999 3.65 3.71999 3.35C4.39999 3 5.27999 3 7.05999 3H15.93C17.7 3 18.59 3 19.27 3.35C19.87 3.65 20.35 4.14 20.65 4.73C20.75 4.92 20.81 5.12 20.86 5.36M22.39 12H12.61M12.61 12L16.61 16M12.61 12L16.61 8",
          }),
          /*#__PURE__*/ _jsx("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M8.32999 3V22M20.98 18.5C20.95 19.3 20.87 19.83 20.65 20.27C20.35 20.87 19.86 21.35 19.27 21.65C18.59 22 17.71 22 15.93 22H7.05999C5.28999 22 4.39999 22 3.71999 21.65C3.11999 21.35 2.63999 20.86 2.33999 20.27C1.98999 19.59 1.98999 18.71 1.98999 16.93V8.07C1.98999 6.3 1.98999 5.41 2.33999 4.73C2.63999 4.13 3.12999 3.65 3.71999 3.35C4.39999 3 5.27999 3 7.05999 3H15.93C17.7 3 18.59 3 19.27 3.35C19.87 3.65 20.35 4.14 20.65 4.73C20.75 4.92 20.81 5.12 20.86 5.36M22.39 12H12.61M12.61 12L16.61 16M12.61 12L16.61 8",
          }),
        ],
      }
    )
  );
};
export default MenuCollapse;

